import * as React from 'react';
import { FunctionComponent } from 'react';
import * as classNames from 'classnames';

interface Props {
  isOpen: boolean;
  title: string;
  closeButtonText: string;
  submitButtonText: string;
  onCloseClick: () => void;
  onNextClick: () => void;
  onPreviousClick: () => void;
  onSendClick: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  isLoadingFile: boolean;
  isError: boolean;
  isNextDisabled: boolean;
}

export const JobWizardModal: FunctionComponent<Props> = props => {
  const { isOpen, isLoadingFile, isError } = props;
  if (!isOpen) {
    return null;
  }

  const modalClasses = classNames({
    mDisplayBlock: isOpen,
    show: isOpen,
    modal: true,
    fade: true,
  });

  const {
    title,
    onCloseClick,
    onNextClick,
    closeButtonText,
    submitButtonText,
    hasNext,
    hasPrevious,
    onPreviousClick,
    onSendClick,
    isNextDisabled,
  } = props;

  const renderButtons = () => {
    if (hasNext) {
      return (
        <button type="button" className="btn btn-primary" onClick={onNextClick} disabled={isNextDisabled}>
          {submitButtonText}
        </button>
      );
    } else {
      return null;
    }
  };

  const renderPreviousStepButton = () => {
    if (hasPrevious) {
      return (
        <button type="button" className="btn btn-primary" onClick={onPreviousClick}>
          Previous step
        </button>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={modalClasses}>
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header d-flex">
            <h5 className="modal-title">{title}</h5>
            {!hasNext ? (
              <div className="ml-auto">
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={onSendClick}
                  disabled={isLoadingFile || isError}
                >
                  Send
                </button>
              </div>
            ) : (
              <button type="button" className="close" onClick={onCloseClick}>
                <span>&times;</span>
              </button>
            )}
          </div>
          <div className="modal-body">{props.children}</div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>
              {closeButtonText}
            </button>
            {renderPreviousStepButton()}
            {renderButtons()}
          </div>
        </div>
      </div>
    </div>
  );
};
